import { useMutation } from "@tanstack/react-query";
import { createAnswerer } from "../../../api/answerer";
import { useAuth } from "../../auth/hooks/useAuth";
import { parseToDate, toFormatString } from "../../../libs/helper";
import { CreateAnswererInput } from "../../answerer/schemas/answererSchemas";

/**
 * 新規回答者作成Hook
 */
export const useCreateNewAnswerer = () => {
    const { csrfToken } = useAuth();

    return useMutation({
        mutationFn: async (input: CreateAnswererInput) => {
            return await createAnswerer(
                input.name,
                input.receiverNickname,
                input.questionSendType,
                input.email,
                input.birthday
                    ? toFormatString(parseToDate(input.birthday), true, "-")
                    : undefined,
                input.relationship,
                input.qmailFrequency,
                csrfToken
            );
        },
    });
};
